import { ICor, ICorRegistro } from '../../modules/types/Cor';
import httpClient from '../httpClient';

const API_BASE = '/api/cores';

export const getAllCores = async (): Promise<ICorRegistro[]> => {
  try {
    const response = await httpClient.get(API_BASE);

    return Array.isArray(response.data?.registros)
      ? response.data.registros
      : [];
  } catch (error: any) {
    throw new Error('Erro ao obter lista de cores: ' + error.message);
  }
};

export const getCorById = async (
  id: string | number,
): Promise<ICorRegistro> => {
  const response = await httpClient.get(`/api/cores/${id}`);
  return response.data;
};

export const handleCreateCor = async (form: ICor): Promise<any> => {
  try {
    const response = await httpClient.post(API_BASE, form);
    return response.data; // { message, registro }
  } catch (error: any) {
    throw new Error('Erro ao criar Cor: ' + error.message);
  }
};

export const handleUpdateCor = async (form: ICor): Promise<any> => {
  try {
    const response = await httpClient.patch(`${API_BASE}/${form.id}`, form);
    return response.data; // { message, registro }
  } catch (error: any) {
    throw new Error('Erro ao atualizar Cor: ' + error.message);
  }
};

export const handleDeleteCor = async (id: string | number): Promise<any> => {
  try {
    const response = await httpClient.delete(`${API_BASE}/${id}`);
    return response.data; // { message }
  } catch (error: any) {
    throw new Error('Erro ao excluir Cor: ' + error.message);
  }
};
